import { Distance, Elevation } from "common/units";
import { routeSelectors } from "data/resources/routes";
import { tripSelectors } from "data/resources/trips";
import { commonNouns, Msg } from "lib/localization";
import { j } from "lib/textUtils";
import { urls } from "lib/urls";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { connect } from "react-redux";
import styles from "./NavigationInfo.scss";

class _NavigationInfo extends React.PureComponent {
  render() {
    const { troute, navObject } = this.props;

    console.log(troute.navType);
    return (
      <div className={styles.NavigationInfo}>
        <h2>
          <Msg
            capitalized
            m={troute.navType === "route" ? commonNouns.routes : commonNouns.trips}
            values={{ count: 1 }}
          />{" "}
          <T id="NavigationInfo.navigated" defaultMessage="Navigated" />
        </h2>
        <hr />
        <div className={styles.container}>
          <div>
            <div className={styles.navItemName}>
              <a href={`/${troute.navType}s/${troute.navId}`}>{troute.navName}</a>
            </div>
            {navObject && (
              <div className={styles.navItemMetrics}>
                <span>{j([navObject.locality, navObject.administrativeArea])}</span>
                <span>
                  <Distance short bigUnits value={navObject.distance} />
                </span>
                <span>
                  <Elevation short value={navObject.elevationGain} />
                </span>
              </div>
            )}
          </div>
          <div>
            <img src={urls.staticMap(troute.navType, "micro", troute.navId)} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  if (!(ownProps.troute.navId && ownProps.troute.navType)) {
    return {};
  }
  const navObject =
    ownProps.troute.navType === "trip"
      ? tripSelectors.find(state, ownProps.troute.navId)
      : routeSelectors.find(state, ownProps.troute.navId);
  return { navObject };
};

export const NavigationInfo = connect(mapStateToProps)(_NavigationInfo);
